(() => {
  if (window.__fsProductCardInit) return;
  window.__fsProductCardInit = true;

  const SPINNER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="fs-pc-spin"><path d="M12 2a10 10 0 1 0 10 10"/></svg>`;
  const CHECK_SVG   = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.fs-product-card__atc[data-variant-id]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    const variantId    = btn.dataset.variantId;
    const originalHTML = btn.innerHTML;

    btn.classList.add('is-loading');
    btn.innerHTML = SPINNER_SVG;
    btn.disabled  = true;

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) throw new Error('Cart add failed');

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.innerHTML = CHECK_SVG;

      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      if (window.Shopify && window.Shopify.onCartUpdate) {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => window.Shopify.onCartUpdate(cart));
      }

      setTimeout(() => {
        btn.classList.remove('is-added');
        btn.innerHTML = originalHTML;
        btn.disabled  = false;
      }, 2000);

    } catch (err) {
      btn.classList.remove('is-loading');
      btn.innerHTML = originalHTML;
      btn.disabled  = false;
      console.warn('[fs-product-card] Add to cart failed:', err);
    }
  });
})();
